import buildInstitutionURL from '$utils/buildInstitutionURL';

// eslint-disable-next-line import/prefer-default-export
export const buildHandinAssignmentURL = ({ space, externalId }) =>
  buildInstitutionURL({
    subdomain: 'handin',
    path: `${space}/${externalId}`,
  });

export const buildHandinSubmissionURL = ({ space, externalId, studentId }) =>
  buildInstitutionURL({
    subdomain: 'handin',
    path: `${space}/${externalId}/submissions/student/${studentId}`,
  });
